import { useMemo } from 'react'
import {isZendeskPage} from './utils';
import {languageCodeEnglish} from "#utils/constants";
import { useHistory } from "#shared/hooks/useHistory";

const useZendesk = (isAuthorized: boolean) => {
    const history = useHistory();
    

    return useMemo(() => {

        if (window.zE) {
            if (isZendeskPage(history.location.pathname, isAuthorized) && languageCodeEnglish) {
                window.zE("webWidget", "show");
            } else {
                window.zE("webWidget", "hide");
            }
        } 
        
        /**
         * In this case you cannot control the zendesk widget
         */
        // else {
        //     console.log('DOES NOT HAVE ZE');
        // }

    }, [history]);
}


export default useZendesk;